import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

import CreateQRcode from "../CreateQRcode/CreateQRcode";
import { Button } from "@/components/index";

import { useModalContext } from "@/shared/contexts/modal";
import { useCustomMenuContext } from "@/contexts/righthClickMenuContext";
import { systemActions } from "@/store/actions";
import { downloadFile } from "@/shared/utils/dom";

import styles from "./CustomContextMenuPopup.module.scss";

const Popup = dynamic(() => import("@/shared/components/Popup/Popup"), {
  ssr: false,
});

const ContextActions = [
  {
    title: "copyLink",
    service: "link",
    justCopy: true,
  },
  {
    title: "saveLink",
    service: "link",
    justSave: true
  },
  {
    title: "createQrCode",
    service: "link",
    justQRcodr: true
  }
];

const CustomContextMenuPopup = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { showModal } = useModalContext();
  const { fnGetUrl, isShown, anchorEl, closePopup } = useCustomMenuContext();
  const [isGettingUrl, setIsGettingUrl] = useState(false);

  const getUrl = useCallback(async () => {
    setIsGettingUrl(true);

    let newUrl = fnGetUrl ? await fnGetUrl : "";
    newUrl = newUrl.includes("http") ? newUrl : window.location.origin + newUrl;

    setIsGettingUrl(false);

    return newUrl;
  }, [fnGetUrl]);

  return (<Popup
    isShown={isShown}
    anchorEl={anchorEl}
    onHide={(e) => {
      e.stopPropagation();
      closePopup(e);
    }}
    contentProps={{
      className: styles["custom-context-menu_wrap"],
    }}
  >
    <nav>
      <ul>
        {ContextActions.map(({ title, justCopy, justQRcodr, justSave }, index) => {
          return (
            <li key={index}>
              <Button
                variant={Button.variant.clear}
                color={Button.color.icon}
                title={t(title)}
                disabled={isGettingUrl}
                onClick={async () => {
                  const url = await getUrl();
                  if (justCopy) {
                    dispatch(
                      systemActions.actionCopy(url, {
                        successMessage: t("linkCopied"),
                        errorMessage: t("linkNotCopied"),
                      }),
                    );
                  }
                  if (justQRcodr && url) {
                    closePopup();
                    showModal(
                      <CreateQRcode value={url} />
                    );
                    return;
                  }
                  if (justSave) {
                    downloadFile("data:text/plain;charset=utf-8," + encodeURIComponent(url), "url");
                  }
                  closePopup();
                }}
              >  {t(title)}
              </Button>
            </li>);
        })}
      </ul>
    </nav>
  </Popup >);
};

CustomContextMenuPopup.propTypes = {
  url: PropTypes.string,
  isShown: PropTypes.bool,
  anchorEl: PropTypes.object,
  rectContextItem: PropTypes.object,
  closePopup: PropTypes.func,
};


export default CustomContextMenuPopup;
